export default {
  en: {
    
  }
};